import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';

import ButtonBase from './BaseButton';

const LinkButton = styled(ButtonBase)`
  && {
    margin: 0;
    padding: 0;
    height: auto;
    display: inline;

    div {
      gap: 4px;
    }

    span {
      margin: 0;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
    }
  }

  &:disabled {
    color: ${COLORS.NEUTRAL_DISABLED};
  }

  &:not(:disabled) {
    color: ${COLORS.ACTION_DEFAULT};

    &:hover {
      color: ${COLORS.ACTION_HOVER};
    }
  }
`;

export default LinkButton;
